import { 
  uuid,
  last_name,
  first_name,
  state_abbr,
  zip,
  city,
  address1,
  company_name,
  phone } from "casual-browserify";

const getRandomInt = (max, inclusive) => {
  let randomInt = Math.floor(Math.random() * Math.floor(max));
  if (!inclusive) {
    randomInt++
  }
  return randomInt;
}

const compare = (a, b) => {
  if (a.lastName < b.lastName) {
    return -1;
  }
  if (a.lastName > b.lastName) {
    return 1;
  }
  return 0;
}

export const getMockUser = () => {
  const firstName = first_name;
  const lastName = last_name;
  return {
    id: uuid,
    firstName,
    lastName,
    hall: uuid,
    hasFavorites: true,
    email: `${firstName}.${lastName}@gmail.com`,
    family: uuid,
    favorites: [uuid, uuid],
    shared: [uuid, uuid, uuid],
    alerts: [uuid, uuid, uuid],
  }
}

export const getMockHall = (id) => {
  return {
    id,
    name: company_name,
  }
}

export const getMockHalls = (n) => {
  const halls = [];
  let i = 0;
  while (i < n) {
    halls.push({
      id: uuid,
      name: company_name
    });
    i++
  }
  return halls;
}

export const getMockAlert = (id) => {
  const firstName = first_name;
  const lastName = last_name;
  return {
    id,
    firstName,
    lastName,
    email: `${firstName}.${lastName}@gmail.com`,
  };
}

export const getMockInfo = (n, ids) => {
  const cards = [];
  while (cards.length < n) {
    const adults = [];
    const dependents = [];
    const emails = [];
    const phones = [];
    const numAdults = getRandomInt(2, false);
    const numDependents = getRandomInt(2, true);
    const lastName = last_name;
    while (adults.length < numAdults) {
      const firstName = first_name;
      adults.push(firstName);
      emails.push(`${firstName}.${lastName}@gmail.com`);
      phones.push(phone);
    }
    while (dependents.length < numDependents) {
      dependents.push(first_name);
    }
    cards.push({
      id: ids ? ids[cards.length] : uuid,
      lastName,
      adults,
      dependents,
      address: address1,
      province: state_abbr,
      city,
      postal: zip(),
      emails, 
      phones,
    });
  }
  let response;
  if (cards.length > 1) {
    cards.sort(compare);
    response = cards;
  } else {
    response = cards[0];
  }
  return response;
}

export const updateMockFamily = () => {
  return Math.random() < 0.7;
}